import { useEffect, useRef } from "react";
import { appStore } from "./store.ts";

/**
 * Mounts the Phaser game once. Phaser is a separate chunk loaded after the
 * React shell has painted, so the first screen appears without waiting for
 * the game engine.
 */
export function GameHost() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let destroyed = false;
    let game: { destroy: (removeCanvas: boolean) => void } | null = null;
    void import("../game/bootstrap/createGame.ts").then(({ createGame }) => {
      if (destroyed || !ref.current) return;
      game = createGame(ref.current, appStore.get().save?.settings.maxDpr ?? 2);
    });
    return () => {
      destroyed = true;
      game?.destroy(true);
    };
  }, []);
  return <div ref={ref} className="game-host" data-testid="game-host" />;
}
